import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import BaseButton from 'reservations/base/components/BaseButton';
import { useSuccessSnackbar } from 'reservations/base/hooks/useSnackbar';
import { useDeleteSavedPaymentMethodMutation } from 'reservations/dinerAccount/queries/deleteSavedPaymentMethodMutation';
import { FormHeader } from 'reservations/form/components/FormHeader';
import {
  DRAWER_STATES,
  useBookingForm
} from 'reservations/form/providers/BookingFormProvider';
import { CardInformation } from 'reservations/payments/components/CardInformation';
import { useDinerPaymentMethods } from 'reservations/payments/hooks/useDinerPaymentMethods';

export const ReplaceSavedCard = () => {
  const {
    defaultPaymentMethod: { id: paymentMethodId, ...cardDetails },
    deletePaymentMethod
  } = useDinerPaymentMethods();
  const enqueueSuccessSnackbar = useSuccessSnackbar();

  const handleSuccess = () => {
    deletePaymentMethod(paymentMethodId);
    enqueueSuccessSnackbar(
      'SAVED_CARD_REMOVED_SNACKBAR',
      'Saved Card Removed!'
    );
  };
  const mutation = useDeleteSavedPaymentMethodMutation({ handleSuccess });
  const { setDrawerState } = useBookingForm();

  const handleReplace = () => {
    mutation.mutate({ paymentMethodId });
    setDrawerState(DRAWER_STATES.INPUT_FIELDS);
  };
  const handleCancel = () => {
    setDrawerState(DRAWER_STATES.INPUT_FIELDS);
  };

  return (
    <Box>
      <FormHeader />
      <Box
        sx={theme => ({
          paddingTop: theme.spacing(4)
        })}
      >
        <Typography>
          We will use the updated card if you are subject to a fee.
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        sx={theme => ({
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(4)
        })}
      >
        <CardInformation {...cardDetails} />
      </Box>
      <Box
        sx={theme => ({
          paddingBottom: theme.spacing(2)
        })}
      >
        <BaseButton label="Replace card" onClick={handleReplace} />
      </Box>
      <BaseButton label="Cancel" onClick={handleCancel} />
    </Box>
  );
};
